<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-08 16:27:51
 * @LastEditors: yd
 * @LastEditTime: 2020-07-23 11:23:09
--> 
<template>

  <v-list dense
          class="threeNavigation"
          :style="{right: level==0?'0px': '195px',top: level==0?'40px': '-5px',}"
          nav>

    <v-hover v-slot:default="{ hover }"
             close-delay='50'
             v-for="(item,index) in list"
             :key='index'>
      <v-list-item class="listItem"
                   @click.prevent.stop="(!item.children || item.children.length <=0)&& handleClick(item)">
        <div v-if="item.children&&item.children.length> 0">
          <mrcEssCascader v-show="hover"
                          @turnPage='handleClick'
                          :list='item.children'
                          :level='item.level' />
        </div>

        <v-list-item-action class="d-flex justify-center align-center"
                            v-if="item.icon">
          <v-icon>{{item.icon}}</v-icon>
        </v-list-item-action>
        <mrc_ess_svgIcon v-if="item.svgName"
                         :iconClass="item.svgName"
                         style="font-size: 23px;" />
        <v-list-item-content style="text-align:left">
          <v-list-item-title>{{item.level == 1 ? index+1 + '.' : ''}}{{item.key}}</v-list-item-title>
        </v-list-item-content>

      </v-list-item>
    </v-hover>
  </v-list>

</template>

<script>
export default {
  name: 'mrcEssCascader',
  components: {},
  props: {
    list: {
      type: Array
    },
    level: {
      type: Number
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  created () { },
  watch: {

  },
  mounted () {

  },

  methods: {
    handleClick (val) {
      this.$emit('turnPage', val)
    }
  },
};
</script>

<style scoped>
.threeNavigation {
  width: 200px;
  position: absolute;
  top: -5px;
  right: 0;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  z-index: 10;
}
.listItem {
  height: 33px;
  padding: 0;
}
.listItem:hover {
  background-color: #ececee;
}
.threeNavigation /deep/ .v-list-item__action {
  margin-right: 0;
}
</style>
